// extracted by mini-css-extract-plugin
module.exports = {"loadingContainer":"Deeplink_loadingContainer__26fam","qrCode":"Deeplink_qrCode__1RA8_"};